export default {
  LIST_FETCHED: 'CREATE_NEW_STATION_FETCHED',
  LIST_LOAD: 'CREATE_NEW_STATION_LOAD',
  ITEM_DETAIL: 'CREATE_NEW_STATION_DETAIL',
  BUTTON_LOAD: 'CREATE_NEW_STATION_BUTTON_LOAD',
};
